const categories = [
  { icon: 'ri-heart-pulse-line', label: '恋爱都市', count: '3,280部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-sword-line', label: '热血冒险', count: '4,150部', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-magic-line', label: '奇幻异世界', count: '2,760部', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-ghost-line', label: '悬疑恐怖', count: '1,540部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-emotion-laugh-line', label: '搞笑日常', count: '2,890部', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-user-star-line', label: '耽美纯爱', count: '1,980部', color: 'bg-secondary-100 text-secondary-700' },
  { icon: 'ri-rocket-line', label: '科幻未来', count: '1,320部', color: 'bg-accent-100 text-accent-700' },
  { icon: 'ri-building-2-line', label: '职场商战', count: '860部', color: 'bg-primary-100 text-primary-700' },
  { icon: 'ri-basketball-line', label: '运动竞技', count: '1,050部', color: 'bg-secondary-100 text-secondary-700' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            漫画分类导航
          </h2>
          <p className="text-sm text-foreground-500">九大品类精准分类，快速找到你的菜</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat, i) => (
            <a
              key={i}
              href="#cards"
              className="bg-background-100 rounded-xl p-5 md:p-6 hover:bg-background-200/70 transition-colors flex items-start gap-4 group cursor-pointer"
            >
              <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${cat.color}`}>
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <div>
                <h3 className="font-heading text-base text-foreground-900 mb-1">{cat.label}</h3>
                <p className="text-xs text-foreground-400">{cat.count}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}